import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dd8fd87&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4dd8fd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.108.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd8fd87",
  null
  
)

export default component.exports